import { useField } from 'formik';

export function Checkbox({ name, ...props }) {
  const [field] = useField({ name, type: 'checkbox' });

  return <input type="checkbox" {...field} {...props} />;
}
